<template>
  <div>
    <div
      v-bind="checkShowRule(this.$store.state.messages, 'date')"
      :key="key"
      ref="time"
      class="message-time"
      :style="{
        width: '100vw',
        marginBottom: message.id === 1 ? '0vw' : '5.6vw'
      }"
    >
      <div v-if="message.is_show_time">
        {{ message.show_time }}
      </div>
    </div>
    <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
  <van-swipe-item>1</van-swipe-item>
  <van-swipe-item>2  border: 3px solid #eee; -->
    <v-flex
      class="message"
      ref="title"
      :style="{ 'max-width': message.type !== 'bot' ? '105vw' : '' }"
    >
      <div v-bind="checkpicture(this.$store.state.messages, 'type')">
        <div
          v-if="message.show_photo"
          style="
            width: 44px;
            height: 44px;
            float: left;
            border-radius: 50%;
            overflow: hidden;
            margin-left: 2vw;
          "
          v-show="this.message.type !== 'human' && this.message.id !== 2"
        >
          <img :src="toolbarLogo" width="40" height="40" />
        </div>
        <div
          v-else
          style="
            width: 44px;
            height: 44px;
            float: left;
            border-radius: 50%;
            overflow: hidden;
          "
          v-show="this.message.type !== 'human' && this.message.id !== 2"
        ></div>
      </div>

      <!-- contains message and response card -->
      <v-layout column ma-2 class="message-layout">
        <!-- contains message bubble and date  d-flex-->

        <v-flex
          class="message-bubble-date-container"
          :style="{ marginLeft: message.type === 'human' ? '-5vw' : '' }"
        >
          <v-layout
            column
            class="message-bubble-column"
            :style="{ width: '100%' }"
          >
            <!-- <div v-if="isdateviewShow"  class="message-time">
            {{ dateview }}
          </div> -->
            <!-- contains message bubble and avatar d-flex -->

            <v-flex
              v-scroll
              class="message-bubble-avatar-container"
              ref="cards"
            >
              <v-layout
                row
                class="message-bubble-row"
                :style="{
                  'flex-direction':
                    message.type === 'human'
                      ? 'row-reverse'
                      : message.id !== 1 &&
                        message.id !== 2 &&
                        message.id !== 0 &&
                        !message.responseCard
                      ? 'column'
                      : '',
                  display: 'flex',
                  'max-width': '105vw',
                  'align-items': 'center',
                }"
              >
                <div
                  v-if="shouldShowAvatarImage"
                  v-bind:style="avatarBackground"
                  tabindex="-1"
                  class="avatar"
                  aria-hidden="true"
                ></div>
                <!-- v-on:focus="onMessageFocus"
                v-on:blur="onMessageBlur" 
                  marginTop:
                    this.$store.state.messages.length === 1 &&
                    !this.animate &&
                    message.id === 0 &&
                    !Focus
                      ? '20vw'
                      : '',-->
                <div
                  tabindex="0"
                  id="message-bubble"
                  class="message-bubble focusable"
                  :style="{
                   
                    display: message.responseCard ? '' : '',
                    'font-family': message.responseCard ? '' : '',
                    width: message.type === 'bot' ? '100%' : 'auto',
                    width: message.id === 2 ? '1500vw' : '',
                    height: message.id === 2 ? 'auto' : '',
                    'padding-right': message.id === 2 ? '7vw' : '',
                    marginRight: message.id === 2 ? '4vw' : '',
                    marginLeft: message.responseCard
                      ? ''
                      : message.type === 'bot'
                      ? '-1.2vw'
                      : '4vw',
                    fontSize: message.id === 2 ? '1.5rem' : '',
                    'border-bottom-right-radius':
                      message.type === 'human'
                        ? '40px'
                        : message.type === 'bot' &&
                          message.id !== 2 &&
                          this.BubbleHeight > 190
                        ? '0px'
                        : '24px',
                    'border-bottom-left-radius':
                      message.type === 'human'
                        ? '40px'
                        : message.type === 'bot' &&
                          message.id !== 2 &&
                          this.BubbleHeight > 190
                        ? '0px'
                        : '24px',
                    background: message.id === 2 ? 'none' : '',
                    'border-top-left-radius': message.responseCard
                      ? '0px'
                      : message.type === 'human'
                      ? '40px'
                      : '24px',
                    'border-top-right-radius':
                      message.type === 'human' ? '0px' : '',
                    'padding-bottom':
                    message.text === 'Aww' ? '6vw' :
                      message.type === 'bot' && message.id === 2
                        ? '4vw'
                        : message.type === 'bot' &&
                          message.id !== 2 &&
                          this.BubbleHeight > 190
                        ? '0vw'
                        : message.type === 'bot' &&
                          message.id !== 2 &&
                          message.id !== 0 &&
                          message.id !== 1 &&
                          !message.responseCard
                        ? '6vw'
                        : '',
                    height:
                      message.type === 'bot' &&
                      message.id !== 2 &&
                      this.message.alts &&
                      this.message.alts.markdown &&
                      this.brandFold &&
                      this.BubbleHeight > 190
                        ? '42vw'
                        : '',
                    'padding-left': message.type === 'human' ? 0 : '',
 padding: message.id === 2 ? '0px !important' :'',
                    /* flex-direction: row-reverse; */
                  }"
                >
                  <div
                    v-if="
                     
                      this.message.text === 'Aww' ||
                      this.message.text === '啊哇' ||
                      this.message.text === 'ああ' ||
                      this.message.text === '噢'
                    "
                    :style="{ display: 'flex' }"
                  >
                    <div 
                    v-if="this.message.type === 'bot' && this.message.text == 'Aww'"
                    :style="{ marginLeft: '2vw', marginTop: '2vw' }">
                      <div v-if="from !== 'login' ">
                        <div>{{ $t("licence.Robot_closing_1_1") }}</div>
                        {{ $t("licence.Robot_closing_1_2") }}
                        <a v-on:click="flag && pushFeedback()">{{
                          $t("licence.Robot_closing_2")
                        }}</a
                        >{{ $t("licence.Robot_closing_3") }}
                      </div>
                      <div v-else>
                        <div>
                          {{ $t("licence.Robot_closing_1_login_1")
                          }}{{ $t("licence.Robot_closing_1_login_2") }}
                        </div>
                      </div>
                    </div>
                  </div>


                <div
                    v-if="
                      this.message.text === 'Sorry' 
                    "
                    :style="{ display: 'flex' }"
                  >
                    <div
                     v-if="
                     
                      this.message.text == 'Sorry' 
                    " 
                    :style="{ marginLeft: '2vw', marginTop: '2vw', hyphens: 'auto' }">
                      <div v-if="from !== 'login'  " >
                        I'm sorry I didn't help you with your problem.
                        Please rephrase it or click the button below to get further help. Also, you can click 
                        <a v-on:click="flag && pushFeedback()">{{
                          $t("licence.Robot_closing_2")
                        }}</a
                        >to contact our Support Team.
                      </div>
                      <div v-else>
                        <div>
                          {{ $t("licence.Robot_closing_1_login_1")
                          }}{{ $t("licence.Robot_closing_1_login_2") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    ref="bubble"
                    :style="{
                      overflow:
                        message.id === 2 || message.responseCard
                          ? ''
                          : 'hidden',
                      height:
                        message.type === 'bot' &&
                        message.id !== 2 &&
                        this.message.alts &&
                        this.message.alts.markdown &&
                        this.brandFold &&
                        this.BubbleHeight > 190
                          ? '42vw'
                          : '',
                      'margin-bottom':
                        message.type === 'bot' &&
                        message.id !== 2 &&
                        this.message.alts &&
                        this.message.alts.markdown &&
                        this.brandFold &&
                        this.BubbleHeight > 190
                          ? '-3vw'
                          : '',
                      marginLeft:
                        message.type === 'bot' &&
                        message.id !== 2 &&
                        !message.responseCard
                          ? '-4vw'
                          : '',
                      'padding-left':
                        message.type === 'bot' &&
                        message.id !== 2 &&
                        message.alts &&
                        message.alts.markdown
                          ? '1em'
                          : '',
                      'font-weight': !message.responseCard
                        ? ''
                        : this.$i18n.locale === 'tc' || 'zh' || 'ja'
                        ? '900'
                        : '',
                    }"
                  >
                    <message-text
                      ref="textBox"
                      v-bind:message="message"
                      v-if="
                        'text' in message &&
                        message.text !== null &&
                        message.text.length
                      "
                      :style="{}"
                    >
                      <!-- <SimpleGallery galleryID="pic" :images="images" /> -->
                    </message-text>
                  </div>
                  <v-icon
                    medium
                    v-if="
                      message.type === 'bot' &&
                      botDialogState &&
                      showDialogStateIcon
                    "
                    v-bind:class="`dialog-state-${botDialogState.state}`"
                    class="dialog-state"
                  >
                    {{ botDialogState.icon }}
                  </v-icon>
                  <div v-if="message.type === 'human' && message.audio">
                    <audio>
                      <source v-bind:src="message.audio" type="audio/wav" />
                    </audio>
                    <v-btn
                      v-on:click="playAudio"
                      tabindex="0"
                      icon
                      v-show="!showMessageMenu"
                      class="icon-color ml-0 mr-0"
                    >
                      <v-icon class="play-icon">play_circle_outline</v-icon>
                    </v-btn>
                  </div>
                  <v-menu
                    offset-y
                    v-if="message.type === 'human'"
                    v-show="showMessageMenu"
                  >
                    <!-- 刷新logo更改 -->
                    <!-- <v-btn slot="activator" icon dark>
           
                    <v-icon
                      class="components-icon components-reload"
                      style="height: 30px; width: 30px"
                    >
          
                    </v-icon>
                  </v-btn> -->
                    <v-list>
                      <v-list-tile>
                        <v-list-tile-title
                          v-on:click="resendMessage(message.text)"
                        >
                          <v-icon>replay</v-icon>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile
                        v-if="message.type === 'human' && message.audio"
                        class="message-audio"
                      >
                        <v-list-tile-title v-on:click="playAudio">
                          <v-icon>play_circle_outline</v-icon>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
                <!-- <SimpleGallery galleryID="pic" :images="images" /> -->

                <div
                  v-show="
                    this.BubbleHeight > 190 &&
                    message.alts &&
                    message.alts.markdown &&
                    message.type === 'bot' &&
                    message.id !== 1 && 
                    message.id !== 2 &&
                    showDialogFeedback &&
                    botDialogState
                  "
                  v-on:click="changeFoldState"
                  :style="{
                    'background-color': 'white',
                    width: '101.55%',
                    'margin-bottom': '0rem',
                    padding: '5vw',
                    'padding-top': '4vw',
                    'padding-bottom': '5.5vw',
                    'margin-left': '-0.9vw',
                    'border-bottom-right-radius': '24px',
                    'border-bottom-left-radius': '24px',
                    '-webkit-touch-callout': 'none',
               
                  }"
                >
                  <!-- <div v-show="message.type === 'bot'" class="border-top"></div> -->
                  <a
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: center;
                      color: #0a79c3;
                      font-size: 1rem;
                    "
                    >{{
                      brandFold
                        ? $t("licence.Robot_massege_ViewMore")
                        : $t("licence.Robot_massege_ViewLess")
                    }}

                    <img
                      :src="require('../assets/up@2x.png')"
                      width="22"
                      height="22"
                      style="margintop: -0.8vw"
                      :style="{ transform: brandFold ? 'rotate(-180deg)' : '' }"
                    />
                  </a>
                </div>
              </v-layout>
            </v-flex>

            <!-- <div
            v-if="
              message.type === 'bot' &&
              botDialogState &&
              showDialogFeedback &&
              message.text !==
                'Aww'&& message.text !=='啊哇' &&  this.message.text !=='ああ' && this.message.text !=='噢' 
            "
            class="feedback-state"
          >

            <div
              v-if="showContent && this.message.alts.markdown"
              v-on:click="changeFoldState"
              :style="{width:auto}"
            >
            
              <a
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  color: #0A79C3;
                  font-size: 1rem;
                "
                >{{
                  brandFold
                    ? $t("licence.Robot_massege_ViewMore")
                    : $t("licence.Robot_massege_ViewLess")
                }}
                <img
                  :src="require('../assets/up@2x.png')"
                  width="22"
                  height="22"
                  style="margintop: -0.8vw"
                  :style="{ transform: brandFold ? '' : 'rotate(-180deg)' }"
              /></a>
            </div>
           
            
          </div>  mt-2
            mr-2
            ml-3-->
            <v-flex
              v-if="shouldDisplayResponseCard"
              class="response-card"
              d-flex
              ref="card"
              v-on:click="cardTest"
            >
              <response-card
                v-for="(card, index) in message.responseCard.genericAttachments"
                v-bind:response-card="card"
                v-bind:key="index"
                :style="{ 'background-color': '#FAFAFA !important' }"
              >
              </response-card>
            </v-flex>

            <div
              class="showme"
              id="show"
              v-if="
                !message.responseCard &&
                message.type !== 'human' &&
                message.id !== 0 &&
                message.id !== 1 &&
                message.id !== 2 &&
                this.message.text !== '啊哇' &&
                this.message.text !== 'ああ' &&
                this.message.text !== '噢' &&
                this.message.text !== 'Aww' && 
                this.message.text !== 'Sorry'
              "
              :style="{
                display: 'flex',
                marginBottom: '-2vw',
                marginTop: '3vw',
                width: 'fit-content',
              }"
            >
              <v-btn
                class="feedback-btn"
                text
                icon
                v-on:click="onButtonClick(positiveIntent)"
                :style="{
                  border: positiveClick ? '' : '',
                  color: 'transparent',
                  background: positiveClick
                    ? '-webkit-linear-gradient(left,#FF8E52,#F3A850)'
                    : '',
                }"
                tabindex="0"
              >
                <img
                  v-if="!positiveClick"
                  :src="require('../assets/happyface@2x.png')"
                  width="23vw"
                  height="23vw"
                />
                <img
                  v-else
                  :src="require('../assets/happyface-light@2x.png')"
                  width="23vw"
                  height="23vw"
                />

                <div
                  v-if="!positiveClick"
                  :style="{
                    color: '#999999',
                    marginLeft: '1vw',
                    'font-weight': 400,
                  }"
                >
                  {{ $t("licence.Robot_problem_solved") }}
                </div>

                <div
                  v-else
                  :style="{
                    color: '#fff',
                    marginLeft: '1vw',
                    'font-weight': 400,
                  }"
                >
                  {{ $t("licence.Robot_problem_solved") }}
                </div>
              </v-btn>

              <!-- <v-icon
              v-on:click="onButtonClick(negativeIntent)"
              v-bind:class="{
                'feedback-icons-negative': !negativeClick,
                negativeClick: negativeClick,
              }"
              tabindex="0"
            >
              thumb_down
            </v-icon> -->

              <v-btn
                class="feedback-btn"
                text
                dark
                icon
                v-on:click="onButtonClick(negativeIntent)"
                :style="{
                  border: negativeClick ? '' : '',
                  color: 'transparent',
                  fontweight: negativeClick ? '200' : '',
                  background: negativeClick
                    ? '-webkit-linear-gradient(left,#FF3846,#F85B66)'
                    : '',
                }"
                tabindex="0"
              >
                <img
                  v-if="!negativeClick"
                  :src="require('../assets/unhappyface@2x.png')"
                  width="23vw"
                  height="23vw"
                  :style="{}"
                />
                <img
                  v-else
                  :src="require('../assets/unhappyface-light@2x.png')"
                  width="23vw"
                  height="23vw"
                />
                <div
                  class="div"
                  v-if="!negativeClick"
                  :style="{
                    color: '#999999',
                    marginLeft: '1vw',
                    'font-weight': 400,
                  }"
                >
                  {{ $t("licence.Robot_problem_unsolved") }}
                </div>
                <div
                  class="div"
                  v-if="negativeClick"
                  :style="{
                    color: '#fff',
                    marginLeft: '1vw',
                    'font-weight': 400,
                  }"
                >
                  {{ $t("licence.Robot_problem_unsolved") }}
                </div>
              </v-btn>
            </div>
            <!-- <v-flex
            v-if="shouldShowMessageDate && isMessageFocused"
            class="text-xs-center message-date"
            aria-hidden="true"
          >
            {{ messageHumanDate }}
          </v-flex> -->
          </v-layout>
        </v-flex>

        <!-- <v-flex
          v-scroll
          id="negativeText"
          v-if="negativeClick"
          :style="{
            display: 'block',
            width: this.ScreenWidth - 20 + 'px',
            marginTop: '4vw',
            color: '#999999',
            'text-align': 'left',
          }"
        >
          <div v-if="from !== 'login'">
            <div>
              <div style="font-weight: 600; font-size: 4vw">
                {{ $t("licence.Robot_closing_1_1") }}
              </div>
              {{ $t("licence.Robot_closing_1_2") }}
              <a v-on:click="flag && pushFeedback()"
                >{{ $t("licence.Robot_closing_2") }} </a
              >{{ $t("licence.Robot_closing_3") }}
            </div>
          </div>
          <div v-else>
            <div style="font-weight: 600; font-size: 4vw">
              {{ $t("licence.Robot_closing_1_login_1") }}
            </div>
            <div>{{ $t("licence.Robot_closing_1_login_2") }}</div>
          </div>
        </v-flex> -->

        <v-flex
          v-if="shouldDisplayResponseCardV2 && !shouldDisplayResponseCard"
        >
          <!-- <v-flex
          v-for="(item, index) in message.responseCardsLexV2"
          class="response-card"
          d-flex
          mt-2
          mr-2
          ml-3
          v-bind:key="index"
        >
          <response-card
            v-for="(card, index) in item.genericAttachments"
            v-bind:response-card="card"
            v-bind:key="index"
          >
          </response-card>
        </v-flex> -->
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- </van-swipe-item></van-swipe> -->
  </div>
</template>

<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
import MessageText from "./MessageText";
import ResponseCard from "./ResponseCard";
import moment from "moment";
import toast from "../components/myToast/index";
import * as dayjs from "dayjs";
import axios from "axios";
import SimpleGallery from "./SimpleGallery.vue";
import PhotoSwipeLightbox from "photoswipe/dist/photoswipe-lightbox.esm.js";
import PhotoSwipe from "photoswipe/dist/photoswipe.esm.js";
// import PhotoSwipeLightbox from 'photoswipe/lightbox';
import "./photoswipe.css";
// import request from '../utils/request'

export default {
  name: "message",
  props: ["message", "feedback", "isTextFocus", 
    "toolbarLogo",
  ],
  components: {
    MessageText,
    ResponseCard,
    moment,
    SimpleGallery,
  },
  data() {
    return {
   
      images: [
        {
          largeURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-200.jpg",
          thumbnailURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/1/img-200.jpg",
          width: 1875,
          height: 2500,
        },
        {
          largeURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-2500.jpg",
          thumbnailURL:
            "https://cdn.photoswipe.com/photoswipe-demo-images/photos/2/img-200.jpg",
          width: 1669,
          height: 2500,
        },
        // {
        //   largeURL:
        //     'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-2500.jpg',
        //   thumbnailURL:
        //     'https://cdn.photoswipe.com/photoswipe-demo-images/photos/3/img-200.jpg',
        //   width: 2500,
        //   height: 1666,
        // },
      ],
      from: "",
      key: 1,
      flag: true,
      timeID: null,
      timer: null,
      isiOS: true,
      BubbleHeight: 0,
      index: 0,
      prevFirst: new Date(),
      ScreenWidth: 0,
      Focus: this.isTextFocus,
      widths: document.documentElement.clientWidth,
      animate: false,
      onLine: true,
      latestMinute: 0,
      showContent: false,
      brandFold: true,
      dateview: moment(new Date()).format("YYYY.MM.DD HH:mm"),
      dateviewShow: true,
      lastdate: new Date(),
      currentDate: new Date(),
      isMessageFocused: false,
      messageHumanDate: "Now",
      positiveClick: false,
      negativeClick: false,
      hasButtonBeenClicked: false,
      disableCardButtons: false,
      positiveIntent: this.$store.state.config.ui.positiveFeedbackIntent,
      negativeIntent: this.$store.state.config.ui.negativeFeedbackIntent,
      hideInputFields:
        this.$store.state.config.ui.hideInputFieldsForButtonResponse,
      queryParams: {
        content: { aa: "bb", cc: "dd" },
        timeStamp: 1663570225258,
        timeZone: "+8",
      },
    };
  },
  watch: {
    isTextFocus(newVal) {
      this.Focus = newVal;
      console.log("isTextFieldFocused--", this.Focus);
    },
  },
  computed: {
    botDialogState() {
      if (!("dialogState" in this.message)) {
        return null;
      }
      switch (this.message.dialogState) {
        case "Failed":
          return { icon: "error", color: "red", state: "fail" };
        case "Fulfilled":
        case "ReadyForFulfillment":
          return { icon: "done", color: "green", state: "ok" };
        default:
          return null;
      }
    },
    isLastMessageFeedback() {
      if (
        this.$store.state.messages.length > 2 &&
        this.$store.state.messages[this.$store.state.messages.length - 2]
          .type !== "feedback"
      ) {
        return true;
      }
      return false;
    },
    botAvatarUrl() {
      return this.$store.state.config.ui.avatarImageUrl;
    },
    agentAvatarUrl() {
      return this.$store.state.config.ui.agentAvatarImageUrl;
    },
    showDialogStateIcon() {
      return this.$store.state.config.ui.showDialogStateIcon;
    },
    showMessageMenu() {
      return this.$store.state.config.ui.messageMenu;
    },
    showDialogFeedback() {
      if (
        this.$store.state.config.ui.positiveFeedbackIntent.length > 2 &&
        this.$store.state.config.ui.negativeFeedbackIntent.length > 2
      ) {
        return true;
      }
      return false;
    },
    showErrorIcon() {
      return this.$store.state.config.ui.showErrorIcon;
    },
    shouldDisplayResponseCard() {
      return (
        this.message.responseCard &&
        (this.message.responseCard.version === "1" ||
          this.message.responseCard.version === 1) &&
        this.message.responseCard.contentType ===
          "application/vnd.amazonaws.card.generic" &&
        "genericAttachments" in this.message.responseCard &&
        this.message.responseCard.genericAttachments instanceof Array
      );
    },
    shouldDisplayResponseCardV2() {
      return (
        this.message.responseCardsLexV2 &&
        this.message.responseCardsLexV2.length > 0
      );
    },
    shouldShowAvatarImage() {
      if (this.message.type === "bot") {
        return this.botAvatarUrl;
      } else if (this.message.type === "agent") {
        return this.agentAvatarUrl;
      }
      return false;
    },
    avatarBackground() {
      const avatarURL =
        this.message.type === "bot" ? this.botAvatarUrl : this.agentAvatarUrl;
      return {
        background: `url(${avatarURL}) center center / contain no-repeat`,
      };
    },
    shouldShowMessageDate() {
      return this.$store.state.config.ui.showMessageDate;
    },
  },
  mounted() {
    // console.log('toolbarLogo-', this.toolbarLogo)
    const leftArrowSVGString = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="28px" height="28px" viewBox="0 0 112 112" enable-background="new 0 0 112 112" xml:space="preserve">  <image id="image0" width="112" height="112" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAQAAABs6TzAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQfmDBMHAiZu4ba1AAAFZ0lEQVR42uXdT0gcVxzA8e8btELtCunFSyPmJE0TakkOXipRclIDlgoh hyTXEAiEXIVAoAmEkOYU8BxPS2kUYgIBcUt60IMk20ZTPFVsL7lYcJvCqtlfD7uzuzO7qzuz74+O Py86Mr99n31vdmfnzfutwliIRy999NFHL12kSj+QK/1ssc4aa6yxrgqmWqEMwFJ8yzBDfEVHk7vk WSXDAr+q3IEGyikucp6ztMVMsMsy86TVim5m67RuuSmvRVe8lpvS7dpUwQ3LnOxow/mxI3My7NqG jMmidlp1LMqYO9yEZI3i/Hgj39vHnZSMFZwfGTlpD9cp92XbKk9EZFvuS6cN3ohsWMf5sSEjZnHt 8kAKzngiIgV5IO2meD2GXzGbjUXpMcG7IJuuZeXYlAu6edflo2tVID7KdZ28O649deOOHpwnU64l DWNKvNZ5adeKPSPdIvEA954fU8k79sIR91iU665b3nTs8Yra8BO9XGCWVg9hW1FgXD2LBJQeshxz 3e4I8Q/9aqPeP+r2kbSTPlQ8OEa6/jlq/UF4jwHXLY4cA9yrt7nOEJUR5kxcTjQewph6sS9QOvmD 467bGjP+4kv1IbipdojePrQ8OM7t8KZQD8pJspj6QGkjduhX76o3hHvw8aHmQTuPgxsCQJngnOsW thznZKL6z8AQlSxfR8s2w3M6uGzkXWWJafKM8l3UHX9T/XW3y1jUU8CnckbOyBk5KzPaTy9n5Gwp +9PoO1ddDa8eopNRn6rn/lPDXWa19t4sd5HQo0SIKkkZKMPRx1ll+k8vsZpH05OMVTFQmbap9OCt 6HkuVx3C+ohBnuJynCS3KvsXm9fN33GmLcONmWRcMy9mxl2+UO+h0oOX4s3KjjOptRe1PWFtXCr+ 4gOvxG2STqLW8XDFzwLIKd7Gz6SrYdqH+2m14vfgxdYy6ehF/UdzUVUEnm81V6tEA7ySSoGk2Ix9 44eWRhrhwS6fq5wHDOrgxe9FQzxoY7A4RIf05ItHNMajKNMKjE40yoMhUOLxX5zTPR2NNsyDPJ96 9OrlNd+LxnnQQa9Hn+6szREt8AD6jAD3J1rimQPuTbTGgz6PE6ZyNyJa5MGJNrrMZR+HKoxwFwJb jPOgS8nvnDb5CMH+AmWTB289UmYfIThQscuDlHFgLdEiD1JK8nxi/nFm+cEFD7atzcIH+1BiZoke HtpXKtRG+IUG0H6puEHkLADr8UxcDXcEDL+tWybm2swCa89aat/6xw0Dt2zyihiLxC2Pdds83VfD 94x1jzW7PMvENUPA/T4xWCOaATbzgcgScS35F51UgVU3PAu9uKoKHpBxw7NAzBQv/GoDxhlyRokL R2PyReVYdskz1ovLKufPD8675BkjzoMPTLvlGSKmy0C1whu3PAPEN8XV+P4liyeuedqJT/wWFZMl /UYg9Z6X0bMsGXh5r+3FpThpXhZ51feq/Rg9y7SRM8kwcTpOkrKmDFQL0Z+qvAFeLTEfPcGSWqgB QmluJEKMGuGFiaPRd6+SJPGW5qz6phFwgp8MtNR2TKifGwBBMof+vvtfVOC2mKO2MES945HrNrYU j4K8o7g4S33gmsXZLZ0hXAvz6i6QVC946LqtseJh7erBBmt4pZ1Xh24N6BKDaqdJYOIXKYPa4CrG yvFpjwJX6/NovFJePeOG63Y3HTcaraLfJxJe6gESX6zjCJRbSXzBnAN9LOopeVQiJrtoFSS+7Bgk vnAcJL70XwmZ5OKNJWKyy2+WkEkuoFpG2iqBmw1Wp7CLTHIR4zIyyWWoy8gDW0g88aXgzRTzH2Qo RjH/DK8OeDH/ELTydQwn6OKz0Ncx/MsWf5r/Oob/AVHcnQF/cTGUAAAAJXRFWHRkYXRlOmNyZWF0 ZQAyMDIyLTEyLTE5VDA3OjAyOjM4KzAwOjAwrSTIuQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0x Mi0xOVQwNzowMjozOCswMDowMNx5cAUAAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjItMTItMTlU MDc6MDI6MzgrMDA6MDCLbFHaAAAAAElFTkSuQmCC"/>
</svg>`;
    if (!this.lightbox) {
      const options = {
        bgOpacity: 1.0,
        zoom: false,
        arrowPrevSVG: leftArrowSVGString,
        arrowNextSVG: leftArrowSVGString,
        closeSVG: leftArrowSVGString,
        // to apply styles just to this instance of PhotoSwipe
        mainClass: "pswp--custom-bg",

        gallery: "#pic",
        children: "a",
        pswpModule: () => import("photoswipe/dist/photoswipe.esm.js"),
      };

      // this.lightbox = new PhotoSwipeLightbox({
      //   gallery: '#pic',
      //   children: 'a',
      //   pswpModule: () => import('photoswipe'),
      // });
      const lightbox = new PhotoSwipeLightbox(options);
      lightbox.on("uiRegister", function () {
        console.log("lightbox---7--");
        lightbox.pswp.ui.registerElement({
          name: "download-button",
          order: 8,
          isButton: true,
          tagName: "a",

          // SVG with outline
          html: {
            isCustomSVG: true,
            inner: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="28px" height="28px" viewBox="0 0 112 112" enable-background="new 0 0 112 112" xml:space="preserve">  <image id="image0" width="112" height="112" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAABwCAQAAABs6TzAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQfmDBMHGC1JHpXmAAAC2ElEQVR42u3cP0tbURjH8ecaCSK2FBGHTAEDLpZOXZq9SAdBZ3F1812I L8BVaFdXhcyKUDeh2EkRuhhoHQxtJCokvy7t6b167j3P5f4590mf73QTrifPJ0a88UiINE3TNE3T NE3TNP9hEpO+ZygOV8MuBhhgFzXfsxQD3MLftsp71IkShe8tR2MFnLEcjRXQSwqUngKlp0DpKVB6 CpSeAqWnQOkpUHoKlJ4CpadA6SlQegqUngKTQxPraBc1HNpYR7PkZyQywCoGAIB91BlnH5n9wSPG 2XXsAwAGWPUH7JqRD93ENEDUcWjO7vriTWEE8Il8YIQHjDDli3gC8Ilc4BMecOKJR4RW6EXqJPKA z3hdtLwBibDIJ3KAFt6iR146ohtYQZ6VeGAnuoAV5fGJyUDUcVBRHpeYBKw4j0eMBwrgcYhxQCE8 N9EOFMRzEW1AYbxk4nOgQF4S8SlQKC+eGAUK5sURw0DhvBjisTk+Fs+zEm8sR3J5VqItuTwWUTbP SZTPSySOBy+WOD48K3G8eH+IfcPrV4qX1/4D2ngEADzmtFo++xZYwz0A4GMOa81hBzuYy2GlTwCA e6xlX+ravLAK20VKPVPbzHTtOtexfYZZapgbS75hlkkamM0EpFrMsd9STKU7vNJToPQUKL3/HjhK ca6fqUf8U231aGiOc7iGzKl/kwyplwkYDOmHufHWt8syyfdgmGEdIiJ0zIXtQzXexWERD2amTvbl NkPvw0/9fwoFajgNTbSZfcF53IUW3MO0V9409kLT3GE+j0W3I39NucSyn+8jaljGZWSWbfdXBYyF X9IXakbu6tEV9Uv2zdACvYrc843eBD9zABLhNX0u8wM2WPXpXXDuPo31yzs4pxW69S2KdEsrHF6K 0MKZcyOlrM4K+Qc9TGADF75tuMAGUlw0sn4GI8wl+kAL1KAXBTyHSf2iLl1RJ/ha8uNqmqZpmqZp RfUbVNtFeRf/sm4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTItMTlUMDc6MjQ6NDUrMDA6MDCT RGnmAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTEyLTE5VDA3OjI0OjQ1KzAwOjAw4hnRWgAAACh0 RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMi0xOVQwNzoyNDo0NSswMDowMLUM8IUAAAAASUVORK5C YII="/>
</svg>`,
            outlineID: "pswp__icn-download",
          },
          onClick: (event, el) => {
            console.log("onClick--", pswp.currSlide.data.src, el);
            if (window.webkit != undefined) {
              // console.log("pictureBg---", this.pictureUrl);
              window.webkit.messageHandlers.saveImage.postMessage(
                pswp.currSlide.data.src
              );
              // window.localStorage.clear();
              // window.webkit.messageHandlers.back.postMessage(null);
            } else {
              console.log("pictureBg---", this.pictureUrl);
              // let imgUrl =
              feedback.saveImage(pswp.currSlide.data.src);
            }
            // if (confirm("Do you want to toggle zoom?")) {
            //   lightbox.pswp.toggleZoom();
            // }
          },

          // Or provide full svg:
          // html: '<svg width="32" height="32" viewBox="0 0 32 32" aria-hidden="true" class="pswp__icn"><path d="M20.5 14.3 17.1 18V10h-2.2v7.9l-3.4-3.6L10 16l6 6.1 6-6.1ZM23 23H9v2h14Z" /></svg>',

          // Or provide any other markup:
          // html: '<i class="fa-solid fa-download"></i>'

          // onInit: (el, pswp) => {
          //   el.setAttribute('download', '');
          //   el.setAttribute('target', '_blank');
          //   el.setAttribute('rel', 'noopener');

          //   pswp.on('change', () => {
          //     console.log('change', el);
          //      if ( confirm('Do you want to toggle zoom?') ) {
          //     lightbox.pswp.toggleZoom();
          //   }
          //     // el.href = pswp.currSlide.data.src;
          //   });
          // }
        });
      });

      lightbox.init();
    }
    const element = document.querySelectorAll("#pic");

    for (let i = 0; i < element.length; i++) {
      const pictures = element[i].querySelectorAll("img");
      let that = this;
      for (let i = 0; i < pictures.length; i++) {
        pictures[i].addEventListener("click", function (event) {
          // window.localStorage.setItem("openPicture", "true");

          // console.log("openPicture---", pictures[i].src);
          // that.images[0].largeURL = pictures[i].src;
          // that.images[0].thumbnailURL = pictures[i].src;

          console.log("openPicturetst---", pictures[i].src, that.images);

          if (window.webkit != undefined) {
            window.webkit.messageHandlers.isHiddenNav.postMessage(true);
          }
        });
      }
    }
    this.from = window.localStorage.getItem("from");
    console.log("this.form====!", this.from);
    //   this.timer = setInterval(() => {
    //      this.key += 1 ;
    //      this.checkShowRule((this.$store.state.messages, 'date'))
    //  }

    //  , 10000)
    window.addEventListener("online", this.update), // 网络由异常到正常时触发
      window.addEventListener("offline", this.update); //网络由正常到异常时触发
    let u = navigator.userAgent,
      app = navigator.appVersion;
    this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    window.addEventListener("touchmove", () => {
      this.animate = true;
      // console.log('2222')
    });
    this.BubbleHeight = this.$refs.bubble.scrollHeight;
    this.ScreenWidth = document.documentElement.clientWidth;
    // console.log('test---', this.BubbleHeight,  this.ScreenWidth)
    // let button = document.getElementById('button');

    // if (domHeight > 90) {
    // 	button.style.display: 'block';
    // } else {
    // 	button.style.display: 'none';
    // }
    // if (height > 200) {
    //   this.showContent = true;
    // }

    console.log("bubble-container---", this.BubbleHeight);
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  beforeDestroy() {
    window.removeEventListener("online", this.update);
    window.removeEventListener("offline", this.update);
    window.removeEventListener("touchmove", () => {
      this.animate = true;
      console.log("2222");
    });
  },
  provide: function () {
    return {
      getRCButtonsDisabled: this.getRCButtonsDisabled,
      setRCButtonsDisabled: this.setRCButtonsDisabled,
    };
  },
  methods: {
    cardTest() {
      this.$refs.card.style.display = "none";
      // this.$refs.title.style.display = "none";
      // this.$refs.cards.style.display = "none";
      // this.$refs.time.style.display = "none";
      console.log("cardTest--", this.$refs.card, this.$refs.cards);
    },
    /**
     * 聊天时间格式化
     * 规则：
     *  1. 每五分钟为一个跨度
     *  2. 今天显示，小时:分钟，例如：11:12
     *  3. 昨天显示，昨天 小时:分钟 例如：昨天 11:12
     *  4. 日期差大于一天显示，年月日 小时:分钟 例如：2021年9月30日 11:12
     * @param date 集合中的时间字符串
     * @param index 下标
     * @returns {string|null}
     */
    msgTimeFormat(date, index) {
      // 第一条消息，将其作为比较用的时间，然后格式化后返回
      console.log("msgTimeFormat---", date, index);

      // if (index === 0) {
      this.prevFirst = date;
      // let prevFirst = date;
      let prev = new Date(this.prevFirst);
      let next = new Date();
      let day = next.getDate() - prev.getDate();
      day = day >= 0 ? day : -day;
      //  console.log('msgTimeFormat prevFirst--',this.prevFirst)
      if (day > 1) {
        return this.dateFormatChina(new Date(this.prevFirst));
      } else if (day === 1) {
        return "昨天 " + prev.getHours() + ":" + this.timeAppendZero(prev);
      } else {
        return prev.getHours() + ":" + this.timeAppendZero(prev);
      }

      // }
      // console.log('msgTimeFormat prevFirst--',this.prevFirst)

      //   let prev = new Date(this.prevFirst);
      //   let next = new Date(date);
      //   // console.log('msgTimeFormat--after-',date,index,this.prevFirst,)

      //   let day = Math.floor((next - prev) / (24 * 60 * 60 * 1000));
      //   let minutes = Math.floor((next - prev) / (1000 * 60));
      //   let dayT = new Date().getDate() - next.getDate();
      //   let yesterdayFlag = dayT === 1 || dayT === -1;
      //   let todayFlag = dayT === 0;

      //   /*
      //   下标越界标志
      //   未越界且分钟差大于5，将当前消息日期作为比较值并替换prevFirst，并根据规则格式化
      //   越界则表示下标走到了最后一位，将其作为要显示的日期赋值给prev，并根据规则格式化
      //  */
      //   let indexOutFlag = this.times.length !== index + 1;
      //   if (indexOutFlag && minutes > 5) {
      //     this.prevFirst = date;
      //     if (!todayFlag && !yesterdayFlag) {
      //       return this.dateFormatChina(next);
      //     } else {
      //       prev = new Date(date);
      //       if (yesterdayFlag) {
      //         return "昨天 " + prev.getHours() + ":" + this.timeAppendZero(prev);
      //       }
      //     }
      //   } else {
      //     prev = new Date(date);
      //   }

      //   if (yesterdayFlag && minutes >= 5) {
      //     return "昨天 " + prev.getHours() + ":" + this.timeAppendZero(prev);
      //   } else if (todayFlag && minutes >= 5) {
      //     return prev.getHours() + ":" + this.timeAppendZero(prev);
      //   }
      //   return null;
    },
    dateFormatChina(date) {
      return (
        date.getFullYear() +
        "年" +
        (date.getMonth() + 1) +
        "月" +
        date.getDate() +
        "日 " +
        date.getHours() +
        ":" +
        this.timeAppendZero(date)
      );
    },
    timeAppendZero(time) {
      return time.getMinutes().toString().length === 1
        ? "0" + time.getMinutes()
        : time.getMinutes();
    },
    checkpicture(arr, type) {
      console.log("checkpicture---", arr);
      arr.forEach((element, index, array) => {
        if (index > 0) {
          element["show_photo"] = this.comparePhoto(
            array[index - 1][type],
            array[index][type],
            array[index - 1]['date'],
            array[index]['date'],
            array[index]['text'],
          );
        } else {
          element["show_photo"] = true;
        }
        console.log("element---", element, index, array);
        return element;
      });
    },
    //判断是否需要展示头像
    comparePhoto(type1, type2, t1, t2, text2) {
      // console.log("checkShowRule-222--", t1, t2, dayjs(t2) - dayjs(t1));
      if(dayjs(t2) - dayjs(t1) < 100000 && type1 === type2 && text2 !== 'Sorry') {
        return false;
      }else {
        return true;
      }
      // return type1 === type2 ? false : true;
    },
    checkShowRule(arr, key) {
      //   this.$api.history.update(arr).then((response)=>{
      //     console.log('response---')
      // })
      // let arrArray = Array.from(arr);
      // const params = { ...this.queryParams };

      // console.log("---", params, this.$store.state.messages);
      // console.log("checkShowRule---", arr, typeof(arr));
      let newArr = arr.map((item, index, array) => {
        // console.log("arr---", item, index, array);
        let obj = this.toggleTime(item[key]);
        item["show_time_type"] = obj.type;
        item["show_time"] = obj.time;
        if (index > 0) {
          item["is_show_time"] = this.compareTimeInterval(
            array[index - 1][key],
            array[index][key]
          );
        } else {
          item["is_show_time"] = true;
        }
        // console.log("checkShowRule--", newArr);
        return item;
      });
      return newArr;
    },

    //根据不同时间的消息，输出不同的时间格式
    toggleTime(date) {
      // console.log('toggleTime---')
      let time;
      let type = this.getDateDiff(date);
      //1：新消息，2：当天消息,3：昨天消息，4：今年消息，5：其他消息
      if (type == 1) {
        time = dayjs(date).format("H:mm"); //新消息，不显示时间，但是要显示"以下为最新消息"
      } else if (type == 2) {
        time = dayjs(date).format("H:mm"); //当天消息，显示：10:22
      } else if (type == 3) {
        time = dayjs(date).format("dddd H:mm"); //一周消息，显示：Wednesday 20:41
      } else if (type == 4) {
        time = dayjs(date).format("MMM D, H:mm");
        //超过一周消息，显示：Sep 26, 15:14
      } else if (type == 5) {
        time = dayjs(date).format("MMM D, YYYY H:mm");
        //非今年消息，显示：Aug 31, 2021 23:59
      }
      return {
        time: time,
        type: type,
      };
    },

    //判断消息类型
    getDateDiff(date) {
      let nowDate = dayjs(new Date()); //当前时间
      let oldDate = dayjs(new Date(date)); //参数时间
      // console.log('nowDate---oldDate---', nowDate, oldDate)
      let result;
      if (nowDate.year() - oldDate.year() >= 1) {
        result = 5;
      } else if (nowDate.date() - oldDate.date() >= 7) {
        result = 4;
      } else if (
        nowDate.date() - oldDate.date() <= 7 &&
        nowDate.date() - oldDate.date() >= 1
      ) {
        result = 3;
      } else if (
        nowDate.hour() - oldDate.hour() >= 1 ||
        nowDate.minute() - oldDate.minute() >= 5
      ) {
        // console.log('2222222222222222222222')
        result = 2;
      } else {
        // console.log('2222222222222222222222---', nowDate, oldDate)
        result = 1;
      }
      return result;
    },

    //判断两个时间差是否大于5分钟
    compareTimeInterval(t1, t2) {
      // console.log("checkShowRule-222--", t1, t2, dayjs(t2) - dayjs(t1));
      return dayjs(t2) - dayjs(t1) >= 300000 ? true : false;
    },

    //  防抖
    // debounce(fn, delay) {
    //   return (function (...args) {
    //     if (timer) {
    //       clearTimeout(timer);
    //     }
    //     timer = setTimeout(() => {
    //       fn.call(this, args);
    //     }, delay);
    //   })();
    // },
    update(res) {
      //  let ts = document.getElementById('text-input');
      // console.log(res);
      this.onLine = res.type === "online";
      if (this.onLine) {
        // ts.style.backgroundColor = '';

        console.log("网络正常22");
      } else {
        // console.log('ts---', ts)
        // ts.style.backgroundColor = 'red';
        // toast({ text: "网络异常,请检查网络设置", time: 1000 });
        console.log("网络异常2222");
      }
    },

    isdateviewShow(testdate) {
      console.log("testdate---", testdate);
      let i = 0;

      if (this.$store.state.messages.length > 2) {
        i = this.$store.state.messages.length - 3;
      }

      this.latestMinute = this.$store.state.messages[i].date;

      console.log("isdateviewShow---", this.latestMinute);

      const timestamp = Math.round(testdate.getTime() / 1000);
      // console.log("testdate---", timestamp);
      const date = new Date(timestamp * 1000);
      const isNew = timestamp * 1000 - this.latestMinute >= 60000;
      return isNew;
    },
    //       isdateviewShow(testdate) {
    // console.log('testdate---',testdate)

    //     let i = 0;

    //     if (this.$store.state.messages.length > 2) {
    //       i = this.$store.state.messages.length - 3;
    //     }
    //     this.currentDate =
    //     this.$store.state.messages[this.$store.state.messages.length - 1].date;
    //     this.lastdate = this.$store.state.messages[i].date;
    //     const dateDiff = Math.round((this.currentDate - this.lastdate) / 1000);
    //     const secsInMn = 60; //1分钟
    //     const secsInHr = 3600;
    //     const secsInDay = secsInHr * 24;
    //     console.log(
    //       "222----",
    //       this.$store.state.messages.length,
    //       this.$store.state.messages[i].id,
    //       this.currentDate,
    //       this.lastdate,
    //       dateDiff
    //     );

    //     if (dateDiff < 10 && this.$store.state.messages.type === 'bot')  {
    //       console.log('33---',this.$store.state.messages)
    //       return false;
    //     }else{

    //     }
    //     return true;
    //   },
    pushFeedback() {
      let that = this;
      if (this.flag) {
        this.disabled === true;
        if (this.onLine === false) {
          if (window.webkit != undefined) {
            let text = this.$t("licence.key_internet_error");
            window.webkit.messageHandlers.showToast.postMessage(text);
          } else {
            let text = this.$t("licence.key_internet_error");
            feedback.showToast(text);
          }
        }
        if (this.onLine === false) return;
        if (window.webkit != undefined) {
          window.webkit.messageHandlers.feedback.postMessage({
            title: "测试分享的标题",
            content: "测试分享的内容",
            url: "https://github.com/maying1992",
          });
        } else {
          feedback.postMessage();
        }
      }
      this.flag = false;
      this.timeID = setTimeout(function () {
        console.log("timeD--", that.flag);
        that.flag = true;
      }, 1000);

      /* eslint-disable */

      console.log("pushFeedback---");
    },
    changeFoldState() {
      console.log("777--", this.BubbleHeight);
      this.brandFold = !this.brandFold;
      // altHtmlMessage()
    },
    setRCButtonsDisabled: function () {
      this.disableCardButtons = true;
    },
    getRCButtonsDisabled: function () {
      return this.disableCardButtons;
    },

    resendMessage(messageText) {
      const message = {
        type: "human",
        text: messageText,
      };
      this.$store.dispatch("postTextMessage", message);
    },
    onButtonClick(feedback) {
      if (!this.hasButtonBeenClicked) {
        this.hasButtonBeenClicked = true;
        if (feedback === this.$store.state.config.ui.positiveFeedbackIntent) {
          this.positiveClick = true;
        } else {
          //  this.scrollBottom();
          this.negativeClick = true;
        }
        const message = {
          type: "bot",
          text: "Sorry",
        };
        this.$emit("feedbackButton");

        this.$store.dispatch("pushMessage", message);
      }
    },
    playAudio() {
      // XXX doesn't play in Firefox or Edge
      /* XXX also tried:
      const audio = new Audio(this.message.audio);
      audio.play();
      */
      const audioElem = this.$el.querySelector("audio");
      if (audioElem) {
        audioElem.play();
      }
    },
    onMessageFocus() {
      if (!this.shouldShowMessageDate) {
        return;
      }
      this.messageHumanDate = this.getMessageHumanDate();
      this.isMessageFocused = true;
      if (this.message.id === this.$store.state.messages.length - 1) {
        this.$emit("scrollDown");
      }
    },
    onMessageBlur() {
      if (!this.shouldShowMessageDate) {
        return;
      }
      this.isMessageFocused = false;
    },
    //判断时间是否是一分钟之内
    isNewMinute(timestamp) {
      const test = this.$store.state.messages;
      console.log("test---", test);
      // console.log("timestamp---", timestamp);
      const date = new Date(timestamp * 1000);
      const isNew = timestamp * 1000 - this.latestMinute >= 60000;
      // console.log('latestMinute---',timestamp * 1000 - this.latestMinute)
      this.latestMinute = this.$store.state.messages[this.index].date;
      this.index = this.index + 1;
      console.log("latestMinute---", isNew, this.latestMinute, this.index);
      return true;
    },
    getMessageHumanDate() {
      const dateDiff = Math.round((new Date() - this.message.date) / 1000);
      const dtime = new Date(); //当前时间
      const secsInMn = 60;
      const secsInHr = 3600;
      const secsInDay = secsInHr * 24;
      // console.log("222----", new Date(),this.message.date,secsInMn);
      if (dateDiff < 1) {
        return `${moment(dtime).format("YYYY.MM.DD HH:mm:ss")}`;
      } else if (dateDiff < secsInMn) {
        // console.log("222----", dateDiff, secsInHr, this.message.date);
        // return `${Math.floor(dateDiff / 60)} min ago`;
        return `test`;
      } else if (dateDiff < secsInDay) {
        return this.message.date.toLocaleTimeString();
        // return `${moment(dtime).format("YYYY.MM.DD HH:mm:ss")}`;
      }
      // return this.message.date.toLocaleString();
      // return `${moment(dtime).format("YYYY.MM.DD HH:mm:ss")}`;
    },
  },
  created() {
    if (
      this.message.responseCard &&
      "genericAttachments" in this.message.responseCard
    ) {
      if (
        this.message.responseCard.genericAttachments[0].buttons &&
        this.hideInputFields &&
        !this.$store.state.hasButtons
      ) {
        this.$store.dispatch("toggleHasButtons");
      }
    } else if (this.$store.state.config.ui.hideInputFieldsForButtonResponse) {
      if (this.$store.state.hasButtons) {
        this.$store.dispatch("toggleHasButtons");
      }
    }
  },
  destroyed() {
    clearTimeout(this.timeID);
  },
  directives: {
    scroll: {
      inserted(el) {
        console.log("el---", el);
        el.scrollIntoView();
      },
    },

    preventReClick: {
      inserted(el, binding) {
        console.log("binding-7", binding);
        el.addEventListener("click", () => {
          if (!el.disabled) {
            console.log("888---");
            el.disabled = true;
            setTimeout(() => {
              console.log("000---");

              el.disabled = false;
            }, binding.value || 300000);
          }
        });
      },
    },
  },
};
</script>

<style scoped>
@font-face {
  font-family: "Poppins";
  src: url("../assets/fonts/Poppins-SemiBold.ttf");
}

/* 更改“more_vert”样式 */
.smicon {
  font-size: 14px;
}

.message,
.message-bubble-column {
  flex: 0 0 auto;
}

.message,
.message-bubble-row {
  max-width: 85vw;
  margin-left: 1vw;
}

.avatar {
  align-self: center;
  border-radius: 50%;
  min-width: calc(2.5em + 1.5vmin);
  min-height: calc(2.5em + 1.5vmin);
  align-self: flex-start;
  margin-right: 4px;
}

.message-time {
  align-self: center;
  color: #999999;
  margin-top: 1vw;
  margin-bottom: 5.6vw;
  /* margin-left: 10vw; */
  /* display: none; */
  display: flex;
  justify-content: center;
  /* position: absolute; */
}

.message-bubble {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border-bottom-left-radius: 24px;
  /* border-radius: 24px; */
  display: inline-flex;
  font-size: calc(1em + 0.25vmin);
  padding: 0 12px;
  width: fit-content;
  align-self: center;
  display: flex;

  flex-direction: column;
}
.border-top {
  /* width: 50%; */
  height: 1px;
  border-top: solid #eeeeee 1px;
  top: -9px;
  position: relative;
}

.focusable {
  /* box-shadow: 0 0.25px 0.75px rgba(0, 0, 0, 0.12),
    0 0.25px 0.5px rgba(0, 0, 0, 0.24); */
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  cursor: default;
}

.focusable:focus {
  /* box-shadow: 0 1.25px 3.75px rgba(0, 0, 0, 0.25),
    0 1.25px 2.5px rgba(0, 0, 0, 0.22); */
  outline: none;
}

.message-bot .message-bubble {
  background-color: #ffffff; /* red-50 from material palette 对话颜色更改*/
}

.message-agent .message-bubble {
  background-color: #ffebee; /* red-50 from material palette */
}
.message-human .message-bubble {
  background: -webkit-linear-gradient(
    left,
    #3ea9d7,
    #0a79c3
  ); /* indigo-50 from material palette  对话颜色更改*/
}

.message-feedback .message-bubble {
  background: -webkit-linear-gradient(left, #0a79c3, #18b1e3);
}

.dialog-state {
  display: inline-flex;
}

.icon.dialog-state-ok {
  color: green;
}
.icon.dialog-state-fail {
  color: red;
}

.play-icon {
  font-size: 2em;
}

.feedback-state {
  display: flex;
  width: auto;
  box-shadow: none;
  flex-direction: column;
  /* display: inline-flex; */
  /* align-self: center; */
  border-bottom-right-radius: 24pt;
  border-bottom-left-radius: 24pt;
  padding-bottom: 3vw;
  padding-top: 3vw;
  margin-top: -4vw;
  margin-left: 1vw;
  margin-bottom: 1vw;
  background-color: #ffffff;
}

.feedback-btn {
  margin-left: 0;
  margin-right: 4vw;
  border-radius: 9pt;
  font-size: 1rem;
  color: #999999;
  /* margin: 5pt; */
  width: 40vw;
  height: 10vw;
  text-transform: none;
  box-shadow: none;
  background-color: #ffffff;

  /* margin-left:7vw; */
}

.icon.feedback-icons-positive {
  /* color: grey;
    text-transform: none; */
  /* color: #E8EAF6; */
  /* color: green; */
  padding: 0.125em;
}

.positiveClick {
  color: green;
  padding: 0.125em;
}

.negativeClick {
  color: red;
  padding: 0.125em;
}

.icon.feedback-icons-positive:hover {
  color: green;
}

.icon.feedback-icons-negative {
  /* color: #E8EAF6; */
  color: grey;
  padding: 0.125em;
}

.icon.feedback-icons-negative:hover {
  color: red;
}

.response-card {
  justify-content: center;
  width: 85vw;
}

.no-point {
  pointer-events: none;
}

/* /deep/.accent {
    background-color: red !important;
    border-color: #0a79c3;
} */

.application .theme--light.card,
.theme--light .card {
  background-color: none !important;
}

.my-swipe .van-swipe-item {
  color: #fff;
  /* font-size: 20px; */
  /* line-height: 150px; */
  text-align: center;
  background-color: #39a9ed;
}

/deep/.van-swipe__track {
  display: flex;
}

/deep/.pswp__top-bar {
  top: 8vw !important;
}

.pswp__counter {
  background-color: red;
}

.pswp--custom-bg {
  --pswp-bg: #7079bf;
}
</style>
